import axios from 'axios'
import qs from 'qs'

const wechatUrl = 'http://qy.chinapsp.cn:48883'
const interfaceUrl = 'https://middleware.choicelink.cn/reportIndex'

/**
 * 
 * @param {String} type 发送信息的类型，emailValid,emailContent,phoneValid,wechat
 * @param {Object} typeParams 发送信息的参数，phoneValid:{validateCode,phone},emailValid:{validateCode,toMail},emailContent:{toMail,title,content},wechat:{}
 * @param {String} content 发送信息的内容
 */
function sendMessage(type = '', typeParams = {}) {
  if (type === '') {
    console.error('未定义类型')
    return false
  }
  let typeMethods = {
    'emailValid': async (typeParams) => {
      if (!typeParams.validateCode || !typeParams.toMail) {
        console.error('emailValid', '请求参数缺失')
        return false
      }
      try {
        let rep = await axios.get(`${interfaceUrl}/mailValidate`, {
          params: typeParams
        })
        if (rep.data.success) {
          return true
        } else {
          return false
        }
      } catch (err) {
        console.error(err)
        return false
      }
    },
    'emailContent': async (typeParams) => {
      if (!typeParams.title || !typeParams.toMail || !typeParams.content) {
        console.error('emailContent', '请求参数缺失')
        return false
      }
      try {
        let rep = await axios.get(`${interfaceUrl}/mailContent`, {
          params: typeParams
        })
        if (rep.data.success) {
          return true
        } else {
          return false
        }
      } catch(err) {
        console.error(err)
        return false
      }
    },
    'choicelink_emailContent': async (typeParams) => {
      if (!typeParams.title || !typeParams.toMail || !typeParams.content) {
        console.error('emailContent', '请求参数缺失')
        return false
      }
      try {
        let rep = await axios.get(`${interfaceUrl}/choicelink_emailContent`, {
          params: typeParams
        })
        if (rep.data.success) {
          return true
        } else {
          return false
        }
      } catch(err) {
        console.error(err)
        return false
      }
    },
    'phoneValid': async (typeParams) => {
      if (!typeParams.validateCode || !typeParams.phone) {
        console.error('phoneValid', '请求参数缺失')
        return false
      }
      try {
        let rep = await axios.get(`${interfaceUrl}/phoneValidate`, {
          params: typeParams
        })
        if (rep.data.success) {
          return true
        } else {
          return false
        }
      } catch(err) {
        console.error(err)
        return false
      }
    },
    'phoneContent': async (typeParams) => {
      if (!typeParams.content || !typeParams.phone) {
        console.error('phoneValid', '请求参数缺失')
        return false
      }
      try {
        let rep = await axios.post(`${wechatUrl}/api/services/app/SmsMessages/SendSmsAsync`, {
          message: typeParams.content,
          mobile: typeParams.phone,
          account: 'xuweiping'
        })
        if (rep.data.success) {
          return true
        } else {
          return false
        }
      } catch(err) {
        console.error(err)
        return false
      }
    },
    'choicelink_phoneContent': async (typeParams) => {
      if (!typeParams.content || !typeParams.phone) {
        console.error('phoneValid', '请求参数缺失')
        return false
      }
      try {
          let rep = await axios.get(`${interfaceUrl}/choicelink_phoneContent`, {
            params: typeParams
        })
        if (rep.data.success) {
          return true
        } else {
          return false
        }
      } catch(err) {
        console.error(err)
        return false
      }
    },
    'wechat': async (typeParams) => {
      // uniqueId 用户名中文英文逗号拼接
      if (!typeParams.uniqueId || !typeParams.contentJson) {
        console.error('wechat', '请求参数缺失')
        return false
      }
      let {title, subTitle, description, url} = typeParams.contentJson
      if (!title || !description) {
        console.error('wechat', '消息内容参数有误')
        return false
      }
      let bTitle = subTitle ? subTitle : '消息'
      let toUrl = url ? url : ''
      // let contentJson = `{"type":"textcard","tittle":"【${bTitle}】${title}","description":"${description}","url":"${toUrl}"}`
      const toUserName = typeParams.uniqueId.replace(',', '|')
      const textCard = {
        title: `【${bTitle}】${title}`,
        description: description,
        url: toUrl
      }

      // let contentJson = {
      //   "type": "textcard",
      //   "title": `【${bTitle}】${title}`,
      //   "description": description,
      //   "url": toUrl
      // }
      try {
        // let rep = await axios.post(wechatUrl + '/fr/message/sendV3', qs.stringify({
        //   appId: typeParams.appId,
        //   uniqueId: typeParams.uniqueId,
        //   contentJson: contentJson
        // }))
        let rep = await axios.post(wechatUrl + '/api/services/app/QYWechatMessage/SendQYWechatTextCardByName', {
          toUserName,
          textCard,
          appShotName: 'wechat'
        })
        if (rep.data.success) {
          return true
        } else {
          return false
        }
      } catch(err) {
        console.error(err)
        return false
      }
    },
    'schedule': async (typeParams) => {
      const { extId, organizer, startDate, endDate, attendeeList, summary, description, location, type = 'create' } = typeParams
      if (!extId || !organizer || !startDate || !endDate || !attendeeList || !summary) {
        console.error('schedule', '请求参数缺失')
        return false
      }
      try {
        const params = {
          appShotName: 'Wechat',
          extId, // 记录ID
          organizer, // 组织者
          startDate, // 开始时间（时间戳）
          endDate, // 结束时间
          attendeeList, // 参与者列表
          summary, // 日程标题
          description, // 日程描述
          reminders: {
            is_remind: 1,
            remind_before_event_secs: 86400, // 默认提前一天提醒
            is_repeat: 0, // 默认不重复提醒
            repeat_type: 0
          },
          location // 日程地址
        }
        let rep = {}
        if (type === 'create') {
          rep = await axios.post(wechatUrl + '/api/services/app/QYSchedule/CreateSchedule', params)
        } else if (type === 'update') {
          rep = await axios.put(wechatUrl + '/api/services/app/QYSchedule/UpdateSchedule', params)
        }
        
        if (rep.data && rep.data.success) {
          return true
        } else {
          return false
        }
      } catch (err) {
        console.error(err)
        return false
      }
    },
    'delSchedule': async (id) => {
      if (!id) {
        console.error('delSchedule', '请求参数缺失')
        return false
      }
      try {
        let rep = await axios.delete(wechatUrl + `/api/services/app/QYSchedule/DeleteScheduleByExtId?ExtId=${id}&AppShotName=Wechat`)
        if (rep.data.success) {
          return true
        } else {
          return false
        }
      } catch (err) {
        console.error(err)
        return false
      }
    }
  }

  return typeMethods[type](typeParams)
}

export default sendMessage